import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { AcceptInvitationDto } from '@/features/public/acceptInvitation/types/AcceptInvitationDto.ts';
import { AcceptInvitationResponseDto } from '@/features/public/acceptInvitation/types/AcceptInvitationResponseDto.ts';

const acceptInvitationApi = {
  accept: (data: AcceptInvitationDto) =>
    fetchPrivateApi<AcceptInvitationResponseDto>(
      'POST',
      'public/accept-invitation',
      data,
      // Token w nagłówku, żeby nie trafiał do logów serwera i proxy jak query string.
      { skipTenantId: true, headers: { 'X-Invitation-Token': data.token } },
    ),
};

export default acceptInvitationApi;
